
import { NotDisturbModeScreenNavigationProps } from "./types"
import React from "react"
import LanguageSettings from "./language-settings"
import { PageRoot } from "~screens/page-root"


// 通知铃声
const LanguageSettingsScreen: React.FC<NotDisturbModeScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <LanguageSettings route={route}/>
    </PageRoot>
  )
}

export default LanguageSettingsScreen
